import React, { useContext, useState, useEffect } from 'react'
import EmployeeForm from '@/product/components/species/employee/EmployeeForm'
import { handleRedirectInternal } from '@/product/common/components'
import CommonContext from '@/product/context/common/commonContext'
import AuthContext from '@/product/context/auth/authContext'
import * as Yup from 'yup'

const EmployeeManage = (props) => {
    const commonContext = useContext(CommonContext)
    const authContext = useContext(AuthContext)
    const data = props.data
    const { user } = authContext
    const { USStates, allCountries, allStates } = commonContext
    const [initialValues, setInitialValues] = useState({
        id: 0,
        emp_email: '',
        confirm_email: '',
        emp_firstname: '',
        emp_lastname: '',
        emp_address1: '',
        emp_phone: '',
        emp_type: 'employee',
        emp_city: '',
        emp_state: '',
        emp_country: '',
        emp_zip: '',
        emp_permissions: [],
    })
    const [passwordInitialValues, setPasswordInitialValues] = useState({
        id: 0,
        change_password: true,
        password: '',
        confirm_password: '',
    })
    const resetFrom = () => {
        setInitialValues({
            id: 0,
            emp_email: '',
            confirm_email: '',
            emp_firstname: '',
            emp_lastname: '',
            emp_address1: '',
            emp_phone: '',
            emp_type: 'employee',
            emp_city: '',
            emp_state: '',
            emp_country: '',
            emp_zip: '',
            emp_permissions: [],
        })
        setPasswordInitialValues({
            id: 0,
            change_password: true,
            password: '',
            confirm_password: '',
        })
        // formik.handleReset()
        // formikPassword.handleReset()
        // setIsLoading(false)
    }
    const employeeFunctionEdit = (single_employee) => {
        if (single_employee.record && props.match?.params?.eid !== '0') {
            const user = single_employee.record
            setInitialValues({
                id: props.match?.params?.eid,
                emp_email: user.emp_email,
                emp_firstname: user.emp_firstname,
                emp_lastname: user.emp_lastname,
                emp_address1: user.emp_address1,
                emp_phone: user.emp_phone,
                emp_type: user.emp_type ? user.emp_type : 'employee',
                emp_city: user.emp_city,
                emp_state: user.emp_state,
                emp_country: user.emp_country,
                emp_zip: user.emp_zip,
                emp_permissions: user?.emp_permissions?.length
                    ? user.emp_permissions.split(',')
                    : [],
            })
            //setReload(!reload)
        } else {
            resetFrom()
        }
        //setIsLoading(false)
    }
    const permission = [
        {
            id: '/dashboard',
            description: 'Dashboard',
        },
        {
            id: '/activity',
            description: 'Customer Activity',
        },
        {
            id: '/billing/all/0',
            description: 'Payments',
        },
        {
            id: '/billing/paid',
            description: 'Paid Payments',
        },
        {
            id: '/billing/unpaid',
            description: 'Unpaid Payments',
        },
        // {
        //     id: '/payments/saved_cards',
        //     description: 'Card Details',
        // },
        {
            id: '/registration_coupon',
            description: 'Coupons List',
        },
        {
            id: '/gift_card',
            description: 'Gift Cards List',
        },
        {
            id: '/albums',
            description: 'Albums',
        },
        {
            id: '/auction/open',
            description: 'Auction Lots',
        },
        {
            id: '/auction/upcomming',
            description: 'Auction Upcoming',
        },
        {
            id: '/auction/draft',
            description: 'Auction Draft',
        },
        {
            id: '/auction/closed',
            description: 'Auction Past',
        },
        {
            id: '/schedulepickup',
            description: 'Schedule Pickup',
        },
        {
            id: '/erp',
            description: 'ERP',
        },
        {
            id: '/erp/auction/draft',
            description: 'ERP Auction Draft',
        },
        {
            id: '/erp/auction/open',
            description: 'ERP Auction Active',
        },
        {
            id: '/erp/auction/closed',
            description: 'ERP Auction Closed',
        },
        {
            id: '/erp/auction/all',
            description: 'ERP All Auctions',
        },

        {
            id: '/listing/all',
            description: 'Active Listing',
        },
        {
            id: '/listing/sold',
            description: 'Sold Listing',
        },
        {
            id: '/listing/unsold',
            description: 'Unsold Listing',
        },
        {
            id: '/listing/draft',
            description: 'Draft Listing',
        },
        {
            id: '/listing/relisted',
            description: 'Relisted Listing',
        },
        {
            id: '/templates/auction',
            description: 'Auction Templates',
        },
        {
            id: '/templates/listing',
            description: 'Listing Templates',
        },
        {
            id: '/users/all',
            description: 'All Users',
        },
        {
            id: '/users/active',
            description: 'Active Users',
        },
        {
            id: '/users/unverified',
            description: 'Unverified Users',
        },
        {
            id: '/users/deactivate',
            description: 'Deactivated Users',
        },
        {
            id: '/users/rejected',
            description: 'Rejected Users',
        },

        {
            id: '/org/all',
            description: 'All Organization Users',
        },
        {
            id: '/org/new',
            description: 'All New Users',
        },
        {
            id: '/org/active',
            description: 'All Active Users',
        },
        {
            id: '/org/unverified',
            description: 'All Unverified Users',
        },
        {
            id: '/org/deactivate',
            description: 'All Deactivate Users',
        },

        {
            id: '/org/Rejected',
            description: 'All Rejected Users',
        },
        {
            id: '/inventory/add',
            description: 'Add Inventory',
        },
        {
            id: '/inventory/active',
            description: 'Active Inventory',
        },
        {
            id: '/report',
            description: 'Report Management',
        },
        {
            id: '/dashboard_analytics',
            description: 'Dashboard Analytics',
        },
        {
            id: '/communications/email',
            description: 'Email Template',
        },
        {
            id: '/communications/sms',
            description: 'SMS Template',
        },
        {
            id: '/return/requested',
            description: 'Return Requested',
        },
        {
            id: '/return/completed',
            description: 'Return Completed',
        },
        {
            id: '/return/cancelled',
            description: 'Return Cancelled',
        },
        {
            id: '/logs/emailLogs',
            description: 'Email',
        },
        {
            id: '/logs/smsLogs',
            description: 'SMS',
        },
        {
            id: '/campaign/create',
            description: 'Create Campaign ',
        },
        {
            id: '/campaign/template',
            description: 'Campaign Email template',
        },
        {
            id: '/messages',
            description: 'Messages',
        },
        {
            id: '/questions_answers',
            description: 'Questions & Answers',
        },
        {
            id: '/ordercontrol/new',
            description: 'Order Control',
        },
        {
            id: '/subscribers',
            description: 'Subscribers',
        },
        // {
        //     id: '/ordercontrol/delivered',
        //     description: 'Delivered',
        // },
        {
            id: '/ordercontrol/undelivered',
            description: 'Pending',
        },
        {
            id: '/ordercontrol/new',
            description: 'Order Control',
        },
        {
            id: '/ordercontrol/intransit',
            description: 'In Transit',
        },
        {
            id: '/ordercontrol/pickup',
            description: 'Ready for Pickup',
        },
        {
            id: '/ordercontrol/completed',
            description: 'Completed Order',
        },
        {
            id: '/ordercontrol/cancelled',
            description: 'Cancelled',
        },
        {
            id: '/invoice/all',
            description: 'All Invoices',
        },
        {
            id: '/invoice/paid',
            description: 'Invoice Paid',
        },
        {
            id: '/invoice/unpaid',
            description: 'Invoice Unpaid',
        },
        {
            id: '/invoice/cancel',
            description: 'Invoice Cancel',
        },

        {
            id: '/videoAuction',
            description: 'Video Auction',
        },
        {
            id: '/videoAuction/broadcast',
            description: 'Video Auction Broad cast',
        },
        {
            id: '/videoAuction/live_auction',
            description: 'Video Auction Live Auction',
        },
        {
            id: '/languageManager',
            description: 'Language Manager',
        },
        {
            id: '/store/themes',
            description: 'Themes',
        },
        {
            id: '/store/configuration',
            description: 'Store Configuration',
        },

        // {
        //     id: '/wallet',
        //     description: 'Wallet',
        // },
        // {
        //     id: '/bid_deposit',
        //     description: 'Bid Deposit',
        // },
        {
            id: '/transaction/payment',
            description: 'Transactions Payment',
        },
        {
            id: '/ui_settings',
            description: 'UI Settings',
        },
        {
            id: '/dynamic/pages',
            description: 'Dynamic Pages',
        },
        {
            id: '/dynamic/table/pages',
            description: 'Dynamic Table',
        },
        {
            id: '/plugins',
            description: 'Plugins',
        },
        {
            id: '/settings/palletPricing',
            description: 'Pallet Pricing',
        },
        {
            id: '/settings/banner',
            description: 'Banner Image',
        },
        {
            id: '/settings/twoFactor',
            description: 'Two Factor Authentication',
        },
    ]
    const [permissionSelect, setPermissionSelect] = useState(permission)

    const validationArray = Yup.object({
        emp_email: Yup.string()
            .email('Invalid email format')
            .required('Required!'),
        confirm_email: Yup.string()
            .email('Invalid email format')
            .oneOf([Yup.ref('emp_email')], 'Email not match')
            .required('Required!'),
        emp_firstname: Yup.string()
            .min(2, 'Mininum 2 characters')
            .max(15, 'Maximum 15 characters')
            .required('Required!'),
        emp_lastname: Yup.string()
            .min(2, 'Mininum 2 characters')
            .max(15, 'Maximum 15 characters')
            .required('Required!'),
        emp_address1: Yup.string().required('Required!'),
        emp_phone: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .required('Required!'),
        emp_type: Yup.string().required('Required!'),
        emp_city: Yup.string().required('Required!'),
        emp_state: Yup.string().required('Required!'),
        emp_country: Yup.string().required('Required!'),
        emp_zip: Yup.number().required('Required!').positive().integer(),
        emp_permissions: Yup.array().required('Required!'),
    })

    const validationArrayPassword = Yup.object({
        password: Yup.string()
            .min(8, 'Minimum 8 characters')
            .required('Required!'),
        confirm_password: Yup.string()
            .oneOf([Yup.ref('password')], 'Passwords not match')
            .required('Required!'),
    })
    const [formikValues, setFormikValues] = useState(initialValues)

    const personalDetailsNew = [
        {
            label: 'First name *',
            type: 'text',
            placeholder: 'Enter your first name',
            class: 'col-sm-6 col-12',
            name: 'emp_firstname',
            autoFocus: true,
        },
        {
            label: 'Last Name *',
            placeholder: 'Enter last name',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'emp_lastname',
        },
        {
            label: 'Phone Number *',
            placeholder: 'Enter phone number',
            type: 'phone',
            class: 'col-sm-6 col-12',
            name: 'emp_phone',
        },
        {
            label: 'Employee Type *',
            placeholder: 'Enter employee type',
            class: 'col-sm-6 col-12',
            type: 'select',
            options:
                user.emp_type === 'super_admin'
                    ? [
                          { value: 'super_admin', show: 'Super admin' },
                          { value: 'admin', show: 'Admin' },
                          { value: 'employee', show: 'Employee' },
                      ]
                    : [{ value: 'employee', show: 'Employee' }],
            name: 'emp_type',
        },
    ]

    personalDetailsNew.push(
        {
            label: 'Email Address *',
            placeholder: 'Enter email address',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'emp_email',
        },
        {
            label: 'Confirm Email Address',
            placeholder: 'Confirm your email address',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'confirm_email',
        }
    )

    const passwordChange = [
        {
            label: 'Password',
            placeholder: 'Enter Password',
            type: 'password',
            class: 'col-sm-6 col-12',
            name: 'password',
        },
        {
            label: 'Re-Enter Password',
            placeholder: 'Re-Enter password',
            type: 'password',
            class: 'col-sm-6 col-12',
            name: 'confirm_password',
        },
    ]

    const locationDetails = [
        {
            label: 'Street Address *',
            placeholder: 'Enter street address',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'emp_address1',
        },
        {
            label: 'Country *',
            placeholder: 'Select country',
            class: 'col-12 col-sm-6',
            type: 'select',
            options: allCountries
                .filter(
                    (country) =>
                        global.ignoreCountry.indexOf(country.isoCode) === -1
                )
                .map((country) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = country.name
                    busCategoryChanged.value = country.isoCode
                    return busCategoryChanged
                }),
            name: 'emp_country',
        },
        {
            label: 'State *',
            placeholder: 'Select state',
            class: 'col-12 col-sm-6',
            type: 'select',
            options: allStates
                .filter(
                    (state) =>
                        (formikValues.emp_country
                            ? formikValues.emp_country.indexOf(
                                  state.countryCode
                              ) !== -1
                            : global.defaultCountry.indexOf(
                                  state.countryCode
                              ) !== -1) &&
                        global.ignoreStates.indexOf(state.isoCode) === -1
                )
                .map((buscat) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = buscat.name
                    busCategoryChanged.value = buscat.isoCode
                    return busCategoryChanged
                }),
            name: 'emp_state',
        },
        {
            label: 'City *',
            placeholder: 'Enter city',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'emp_city',
        },
        {
            label: 'ZIP *',
            placeholder: 'Enter ZIP',
            type: 'number',
            class: 'col-sm-6 col-12',
            name: 'emp_zip',
        },
    ]

    useEffect(() => {
        if (formikValues.emp_type === 'super_admin') {
            permission.push(
                {
                    id: '/employees/all',
                    description: 'All Employees',
                },
                {
                    id: '/settings/static',
                    description: 'Static Pages',
                },
                {
                    id: '/settings/general',
                    description: 'General Settings',
                },
                {
                    id: '/settings/maintenance',
                    description: 'Maintenance',
                },
                {
                    id: '/settings/banner',
                    description: 'Banner Image',
                },
                {
                    id: '/settings/category',
                    description: 'Category',
                },
                {
                    id: '/settings/condition',
                    description: 'Condition',
                },
                {
                    id: '/settings/make',
                    description: 'Make',
                },
                {
                    id: '/settings/model',
                    description: 'Model',
                },
                {
                    id: '/settings/manufacturer',
                    description: 'Manufacturer',
                },
                {
                    id: '/settings/location',
                    description: 'Location',
                },
                {
                    id: '/settings/bid_increments',
                    description: 'Bid Increments',
                },
                {
                    id: '/change_password',
                    description: 'Change Password',
                },
                {
                    id: '/settings/tax_code',
                    description: 'Tax code',
                }
            )
            setPermissionSelect(permission)
        } else if (formikValues.emp_type === 'admin') {
            permission.push({
                id: '/employees/all',
                description: 'All Employees',
            })
            setPermissionSelect(permission)
        } else {
            setPermissionSelect(permission)
        }
    }, [formikValues.emp_type])

    useEffect(() => {
        setFormikValues(initialValues)
    }, [initialValues])

    const permissionDetails = [
        {
            type: 'check',
            class: 'empPermissions d-flex align-items-center flex-wrap',
            name: 'emp_permissions',
            options: permissionSelect,
        },
    ]

    const formikValueUpdate = (value) => {
        setFormikValues(value)
    }

    const closeFunction = () => {
        resetFrom()
        history.goBack()
    }

    return (
        <EmployeeForm
            data={props?.data}
            isnotCustom={props?.data ? false : true}
            initialValues={initialValues}
            passwordInitialValues={passwordInitialValues}
            validationArray={validationArray}
            validationArrayPassword={validationArrayPassword}
            permissionDetails={permissionDetails}
            locationDetails={locationDetails}
            passwordChange={passwordChange}
            personalDetailsNew={personalDetailsNew}
            toggleFullScreenPopup={props.function}
            formikValueUpdate={formikValueUpdate}
            employeeFunctionEdit={employeeFunctionEdit}
            resetFrom={resetFrom}
            custom={props?.custom}
            employeeId={
                props?.match?.params?.eid
                    ? parseInt(props?.match?.params?.eid)
                    : 0
            }
            employeeStatus={'new'}
            closeFunction={closeFunction}
        />
    )
}

export default EmployeeManage
